const round = (num: any) => Math.round((parseFloat(num) + 0.00001) * 100) / 100
const optionsUsd = { style: 'currency', currency: 'USD', numberingSystem: "latn" };
const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);
const optionsCR = { style: 'currency', currency: 'CRC' };
const numberFormatCR = new Intl.NumberFormat('es-CR', optionsCR);

const propLoading = {
    txtMsg: 'Cargando...',
    active: false
} as IModalProps

const propMsg = {
    txtMsg: 'Debe llenar le siguiente campo',
    active: false
} as IModalProps

const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '13px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '13px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            boxShadow: 0,
            "text-align-last": "left",
            // "outline-style": state.isFocused ? "none" : "",
            //"border-left": state.isFocused ? "2px solid #008964" : "2px solid #e4e4e4",
            // "border-bottom": state.isFocused ? "1px solid #bae6da" : "",
            // "border-top": state.isFocused ? "1px solid #bae6da" : "",
            // "border-right": state.isFocused ? "1px solid #bae6da" : "",
            '&:hover': {
                border: '0 !important',
                "outline-style": "none !important",
                "border-left": "2px solid #008964 !important",
                "border-bottom": "1px solid #bae6da !important",
                "border-top": "1px solid #bae6da !important",
                "border-right": "1px solid #bae6da !important",
            },
            selectProps: {
                backgroundColor: "#008964",
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const GetDataRates = (data: IIncendioHogarCR) => {
    const obj: Record<string, any> = {
        'TipoBienSA2': data.typeBien_Id2,
        'TipoBienSA3': data.typeBien_Id3,
        'usoin': 0
    };

    let coveragesDet = data.lstCoverages['coverages'];
    let coverageIdsStr = "[";

    coveragesDet.map((x: ICoverages) => {
        type Org = { [key: string]: string }
        obj[`Cob${x.idCob}`] = 1;
        coverageIdsStr = coverageIdsStr + `${x.idCob},`;
    });
    coverageIdsStr = coverageIdsStr.substring(0, coverageIdsStr.length - 1) + "]";
    obj["coverageIds"] = coverageIdsStr;

    return obj;
}

const GetResumen = (data: IIncendioHogarCR): IIncendioHogarCRResumen => {

    let coveragesDetail: Array<IIncendioHogarCRCoverage> = [];

    data.lstCoverages['coverages'].sort((x: ICoverages, y: ICoverages) => { return (x.obligatoria === y.obligatoria) ? 0 : x.obligatoria ? -1 : 1; }).map((cover: ICoverages) => {
        let rate: IRates = data.lstRate['rates'].find((r: IRates) => r.idCob === cover.idCob && !r.bIncluirCob);
        if (rate != undefined) {
            let insuredMout = parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1);
            let det: IIncendioHogarCRCoverage = {
                name: cover.nombre,
                insured: data.currency === 'U$' ? numberFormatUsd.format(insuredMout) : numberFormatCR.format(insuredMout),
                sa: rate.sa,
                value: data.currency === 'U$' ? numberFormatUsd.format(parseFloat(rate.sa)) : numberFormatCR.format(parseFloat(rate.sa))
            }
            coveragesDetail.push(det);
        }
    });



    let financing: number = 0;
    let porDesc = data.planConfig.descuentoMaximo !== undefined ? data.planConfig.descuentoMaximo : 0;
    let taxFinancing = data.planConfig.intereses !== undefined ? data.planConfig.intereses : undefined;

    let bonus = roundToTwo(data.lstRate['rates'].map((x: any) => ({ ...x, prima: roundToTwo(x.prima) + roundToTwo((x.prima * x.pRecargo) / 100) })).sum('prima'));

    let desc = roundToTwo(data.lstRate['rates'].map((x: any) => ({ ...x, desc: roundToTwo((x.prima * x.pRecargo) / 100) * (porDesc * 100) })).sum('desc'));

    let bonus2 = roundToTwo(bonus - desc);

    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === parseInt(data.paymentFrequency));
        if (taxP !== undefined)
            financing = roundToTwo((bonus * (parseFloat(taxP.porcentajeInteres) / 100)));
    }

    let tax = roundToTwo(bonus2 * (parseFloat(data.planConfig.impuestos.interes) / 100));

    let total = roundToTwo(bonus2 + tax + financing);

    let bonusAnnual = roundToTwo(bonus2 + tax + getFrecuency(taxFinancing, 1, bonus)) / 1;
    let bonusSemester = roundToTwo(bonus2 + tax + getFrecuency(taxFinancing, 2, bonus)) / 2;
    let bonusQuarterly =  roundToTwo(bonus2 + tax + getFrecuency(taxFinancing, 4, bonus)) / 4;
    let bonusMonthly = roundToTwo(bonus2 + tax + getFrecuency(taxFinancing, 12, bonus)) / 12;

    let result: IIncendioHogarCRResumen = {
        coverageDetail: coveragesDetail,
        bonus: bonus,
        desc: desc,
        bonus2: bonus2,
        tax: tax,
        financing: financing,
        total: total,

        bonusStr: data.currency === 'U$' ? numberFormatUsd.format(bonus) : numberFormatCR.format(bonus),
        descStr: data.currency === 'U$' ? numberFormatUsd.format(desc) : numberFormatCR.format(desc),
        bonus2Str: data.currency === 'U$' ? numberFormatUsd.format(bonus2) : numberFormatCR.format(bonus2),
        taxStr: data.currency === 'U$' ? numberFormatUsd.format(tax) : numberFormatCR.format(tax),
        financingStr: data.currency === 'U$' ? numberFormatUsd.format(financing) : numberFormatCR.format(financing),
        totalStr: data.currency === 'U$' ? numberFormatUsd.format(total) : numberFormatCR.format(total),

        bonusAnnual: data.currency === 'U$' ? numberFormatUsd.format(bonusAnnual) : numberFormatCR.format(bonusAnnual),
        bonusSemester: data.currency === 'U$' ? numberFormatUsd.format(bonusSemester) : numberFormatCR.format(bonusSemester),
        bonusQuarterly: data.currency === 'U$' ? numberFormatUsd.format(bonusQuarterly) : numberFormatCR.format(bonusQuarterly),
        bonusMonthly: data.currency === 'U$' ? numberFormatUsd.format(bonusMonthly) : numberFormatCR.format(bonusMonthly),
        bonusFrecuencia: 0,
    }


    return result;
}

const getFrecuency = (taxFinancing: any, frecuency: number, bonus: number) => {
    let financing: number = 0;
    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === frecuency);
        if (taxP !== undefined)
            financing = roundToTwo((bonus * (parseFloat(taxP.porcentajeInteres) / 100)));
    }
    return financing;
}


const roundToTwo = (value: number, decimals = 2): number => {
    return Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals);
}

const findInteresByFrecuency = (month: number) => {
    switch (month) {
        case 2: return 2;
        case 4: return 3;
        case 12: return 12;
        default: return 1;
    }
}

const BuildData = ({ data, src }: IBuildData_IHCR_Props): any => {
    let policy: any = {
        'Plan': data.idPlan,
        'SA': roundToTwo(parseFloat(data.typeBien_Id2.toString()) + parseFloat(data.typeBien_Id3.toString())),
        'Prima': data.summary?.bonus,
        'Descuento': data.summary?.desc,
        'PrimaDE': data.summary?.bonus,
        'PrimaNeta': data.summary?.bonus2,
        'PrimaExonerada': 0,
        'Impuesto': data.summary?.tax,
        'Total': data.summary?.total,
        'Frecuencia': data.paymentFrequency,
        'Cuotas': GetFee(data.paymentFrequency),
        'Estado': 0,
        'mInteres': data.summary?.financing,
        'Source': src
    };

    let insured = {
        'TipoId': data.identificationType,
        'NumId': data.identification,
        'Nombre': `${data.firstName1} ${data.firstName2}`,
        'Apellido': `${data.lastName1} ${data.lastName2}`,
        'TelefonoCelular': data.phoneNumber,
        'Email': data.mail,
        'EstadoCivil': '0'
    }

    let LstOA_Items: any = []
    ///OAS ITEM 

    let oaEdificio: any = {
        'TipoBien_Id': 2,
        'Tipo': 1,
        'Clasificacion': '2',
        'Descripcion': 'EDIFICIO',
        'SA': data.typeBien_Id2,
        'pRiesgo': '2'
    }

    let oaContenido: any = {
        'TipoBien_Id': 3,
        'Tipo': 2,
        'Clasificacion': '2',
        'Descripcion': 'CONTENIDO',
        'SA': data.typeBien_Id3,
        'pRiesgo': '2'
    }

    LstOA_Items.push(oaEdificio);
    LstOA_Items.push(oaContenido);

    let Oa = {
        'SA': roundToTwo(parseFloat(data.typeBien_Id2.toString()) + parseFloat(data.typeBien_Id3.toString())),
        'inSumaEdificio': data.typeBien_Id2,
        'inSumaContenido': data.typeBien_Id3,
        'inAnioConstruccion': data.yearConstruction,
        'inDireccion': data.address,
        'inPais': '506',
        'inDepartamento': data.province,
        'inCiudad': data.canton,
        'inDistrito': data.district,
        'inBarrio': data.neighborhood,
        'OA_Items': LstOA_Items
    };

    //COBERTURAS
    let polCobs: any = [];

    data.lstCoverages['coverages'].sort((x: ICoverages, y: ICoverages) => { return (x.obligatoria == y.obligatoria) ? 0 : (x.obligatoria ? -1 : 1); }).map((cover: ICoverages) => {

        let tempCover: any = {};

        tempCover["Nombre"] = cover.nombre;
        tempCover["orden"] = cover.orden;

        let rate: IRates = data.lstRate['rates'].find((r: IRates) => r.idCob == cover.idCob && !r.bIncluirCob);
        if (rate != undefined) {
            tempCover["IdCob"] = rate.idCob;
            tempCover["SA"] = rate.sa;
            tempCover["Prima"] = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
            tempCover["ptasa"] = rate.pTasa;
            tempCover["pdescuento"] = 0;
            tempCover["mdescuento"] = 0;
            tempCover["mprimabruta"] = rate.prima;
            tempCover["PrimaDE"] = rate.prima;
            tempCover["Etiqueta"] = 0;
            tempCover["bDescuentoManual"] = 0;
            tempCover["PrimaGravada"] = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
        }

        if (tempCover["SA"] !== '0.00' && tempCover["SA"] !== '0')
            polCobs.push(tempCover);
    });


    //


    let lstBeneficiary: any = [];
    let lstAnswers: any = [];

    policy["Respuesta"] = lstAnswers;
    policy["Beneficiarios"] = lstBeneficiary;
    policy["Oa"] = Oa;
    policy["Asegurado"] = insured;
    policy["PolCobs"] = polCobs;

    return policy;
}

const BuildDataOportunity = ({ data, src }: IBuildData_IHCR_Props) => {
    let dataOportunity: INotificationOportunity = {
        TipoId: parseInt(data.identificationType),
        Identificacion: data.identification,
        Nombre: `${data.firstName1} ${data.firstName2}`,
        Apellido: `${data.lastName1} ${data.lastName2}`,
        Email: data.mail,
        Celular: data.phoneNumber,
        Source: src == undefined ? '' : src,
        Nombres: `${data.firstName1} ${data.firstName2}`
    }

    return dataOportunity;
}

const GetFee = (type: string) => {
    switch (type) {
        case "1": return 1; // anual
        case "12": return 12; // mensual
        case "2": return 2; // semestral
        case "4": return 4; // trimestral
        default: return 1;
    }
}



export { customStyles, GetDataRates, GetResumen, propLoading, propMsg, BuildData, BuildDataOportunity };